import { X } from 'lucide-react';

export interface SelectedChipItem {
  value: string;
  label: string;
  removeLabel?: string;
}

export interface SelectedChipsProps {
  items: SelectedChipItem[];
  onRemove: (value: string) => void;
}

export function SelectedChips({ items, onRemove }: SelectedChipsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {items.map((item) => {
        const removeLabel = item.removeLabel ?? `Elimină ${item.label}`;

        return (
          <div
            key={item.value}
            className="inline-flex items-center rounded-lg bg-blue-100 px-2 py-1 text-xs text-blue-800">
            {item.label}
            <button
              type="button"
              onClick={() => onRemove(item.value)}
              className="ml-1 hover:text-blue-600"
              aria-label={removeLabel}
              title={removeLabel}>
              <X className="h-3 w-3" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
